import { apiRequest } from '../../shared/api/base'
import type { ActivityItem } from './types'

interface ActivityFeedResponse {
  items: ActivityItem[]
  nextCursor: string | null
}

interface FetchOptions {
  cursor?: string
  limit?: number
  eventType?: string[]
}

export async function fetchActivityFeed(opts: FetchOptions = {}): Promise<ActivityFeedResponse> {
  const params = new URLSearchParams()
  if (opts.cursor) params.set('cursor', opts.cursor)
  if (opts.limit) params.set('limit', String(opts.limit))
  if (opts.eventType?.length) params.set('eventType', opts.eventType.join(','))
  const qs = params.toString()
  return apiRequest<ActivityFeedResponse>(`/activity${qs ? `?${qs}` : ''}`)
}
